import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../utils/routes/MusicRoutes'
import { ClientsRouter } from '../../utils/routes/UsersRoutes'
import { Button, Checkbox, Flex, Form, Input, message } from 'antd'
import {
  attemptBan,
  attemptCreateUser,
  attemptDelete,
  attemptUnban,
  attemptValidate,
  RegistrationDTO,
} from '../../utils/redux/usersSlice'
import {
  listenerMiddleware,
  store,
  useAppDispatch,
  useAppSelector,
} from '../../utils/redux/store'
import { useAttemptListener } from 'dev-masters-react-kit'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { FaCity } from 'react-icons/fa6'

//"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2N2E0ODYzZTk5M2E4ZmMwNGVlNGYxMjQiLCJlbWFpbCI6ImRldkBkZXYuY29tIiwibmFtZSI6Ik5ldyB1c2VyIiwiaWF0IjoxNzM4ODM1NTE4LCJleHAiOjE3NzAzNzE1MTh9.WY52aZqrsaVs5xkTRuhZDmYdM6LSfHG95YLezFFrlSI"
//dev@dev.com
//dev@dev.com
export default function ModifyClient() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const useId = useParams().id
  const users = useAppSelector((state) => state.user.users)
  console.log(users)
  const user = useAppSelector((state) => state.user.users[useId || ''])

  function validate() {
    dispatch(attemptValidate(user._id))
  }

  function ban() {
    dispatch(attemptBan(user._id))
  }

  function unban() {
    dispatch(attemptUnban(user._id))
  }

  function deleteUser() {
    dispatch(attemptDelete(user._id))
  }

  const validateLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptValidate,
    onFulfilled: () => {
      message.success('User has been validated successfully!')
      navigate('/users/clients/all')
    },
    onRejected: (action) => message.error(action.error.message),
  })

  const banLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptBan,
    onFulfilled: () => {
      message.success('User has been banned successfully!')
      navigate('/users/clients/all')
    },
    onRejected: (action) => message.error(action.error.message),
  })

  const unbanLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptUnban,
    onFulfilled: () => {
      message.success('User has been unbanned successfully!')
      navigate('/users/clients/all')
    },
    onRejected: (action) => message.error(action.error.message),
  })

  const deleteLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptDelete,
    onFulfilled: () => {
      message.success('User has been deleted successfully!')
      navigate('/users/clients/all')
    },
    onRejected: (action) => message.error(action.error.message),
  })

  if (!user) {
    message.error({content: 'User not found!', key: useId})
    return <Navigate to="/users/clients/all" />
  }

  return (
    <>
      <Form
        initialValues={{
          email: user.email,
          name: user.name,
          city: user.city,
          businessType: user.businessType,
          identifier: user.identifier,
        }}
        disabled={true}
      >
        <Form.Item
          name="name"
          rules={[{ required: true, message: 'Please input customer name!' }]}
        >
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input the email!' },
            { type: 'email', message: 'Invalid email, example: user@gmail.com!' },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="city"
          rules={[{ required: true, message: 'Please provide customer city!' }]}
        >
          <Input placeholder="City" />
        </Form.Item>
        <Form.Item
          name="businessType"
          rules={[{ required: true, message: 'Please provide customer business type!' }]}
        >
          <Input placeholder="Business type" />
        </Form.Item>
        <Form.Item
          name="identifier"
          rules={[{ required: true, message: 'Please provide customer identifier!' }]}
        >
          <Input placeholder="Identifier" />
        </Form.Item>
      </Form>
      <Flex justify="space-between">
        <Button type="primary" danger onClick={deleteUser} loading={deleteLoading}>
          Delete user
        </Button>
        {!user.validatedAt && (
          <Button type="primary" onClick={validate} loading={validateLoading}>
            Validate
          </Button>
        )}
        {user.validatedAt &&
          (user.bannedAt ? (
            <Button type="default" onClick={unban} loading={unbanLoading}>
              Unban
            </Button>
          ) : (
            <Button type="default" onClick={ban} loading={banLoading}>
              Ban
            </Button>
          ))}
      </Flex>
    </>
  )
}
